import $ from "jquery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

export function header_scrolltrigger() {
    gsap.registerPlugin(ScrollTrigger);
    gsap.timeline({
        scrollTrigger: {
            start: "top -300",
            end: 99999,
            toggleClass: {
                className: 'bg',
                targets: '.header'
            },
        }
    });
};
export function header_init() {
    header_scrolltrigger();

    if (winW <= 890) {
        $('.subnav_box').slideUp(0);
    }
};



const winW = window.innerWidth;
export function subnav_show($e) {
    $($e.target).parent().addClass('show');
};
export function subnav_hide($e) {
    $($e.target).removeClass('show');
};
export function subnav_toggle($e) {

    if (winW > 890) return;

    if ($($e.target).attr('show') === '0' || $($e.target).attr('show') === undefined) {
        $($e.target).parent().find('.subnav_box').slideDown();
        $($e.target).attr('show', '1');
    } else {
        $($e.target).parent().find('.subnav_box').slideUp();
        $($e.target).attr('show', '0');
    }
};



/**
 * 監聽 `menu_open` 變數，並執行 GSAP 動畫
 * @param {Object} vueInstance Vue 應用的 `this`
 */

export function m_menu_open(vueInstance) {
    return function (_menu_open) {
        if (_menu_open) {
            gsap.to(".nav", {
                duration: 0.4,
                opacity: 1,
                display: "block",
                ease: "quart.out",
            });
        } else {
            gsap.to(".nav", {
                duration: 0.4,
                opacity: 0,
                display: "none",
                ease: "quart.out",
            });

            if (winW <= 890) {
                $('.subnav_box').slideUp(0);
            }
        }
    };
}